import { useQuery } from "@tanstack/react-query";
import { engineError } from "@/lib/engine-error";
import type { BenchEnvelope } from "@/lib/profitability-api";

/**
 * Internal and unassigned capacity: the cost the company margin leaves out.
 *
 * One object, not a list -- the categories are a breakdown of a single figure
 * and the reconciliation beside them is the actual subject.
 */
export function useBench(range?: string) {
  return useQuery({
    queryKey: ["bench", range ?? "default"],
    queryFn: async (): Promise<BenchEnvelope> => {
      const params = new URLSearchParams();
      if (range) params.set("range", range);
      const qs = params.toString();
      const response = await fetch(`/api/bench${qs ? `?${qs}` : ""}`);
      if (!response.ok) {
        throw await engineError(response, "Could not load bench cost");
      }
      return response.json();
    },
    staleTime: 5 * 60 * 1000,
  });
}
